import { render, staticRenderFns } from "./UpdateIsAutoAlloc.vue?vue&type=template&id=570323e1"
import script from "./UpdateIsAutoAlloc.vue?vue&type=script&lang=js"
export * from "./UpdateIsAutoAlloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports